import { createQueryHook } from "../factory";

const capabilitiesKeys = {
  all: ["capabilities"] as const,
  list: (input: { filter?: string[] }) =>
    [...capabilitiesKeys.all, "list", input.filter ?? null] as const,
};

const featureFlagsKeys = {
  all: ["featureFlags"] as const,
  dynamic: ({
    key,
    type,
    defaultValue,
  }: {
    key: string;
    type: string;
    defaultValue: unknown;
  }) => [...featureFlagsKeys.all, "dynamic", key, type, defaultValue] as const,
};

export const api = {
  capabilities: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.api.capabilities,
    queryKeyFn: capabilitiesKeys.list,
  }),
  featureFlagDynamic: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.api.featureFlagDynamic,
    queryKeyFn: featureFlagsKeys.dynamic,
  }),
};
